import { Box, Paper, Typography } from '@mui/material';
import TrainingDetailCollapsibleSection from './TrainingDetailCollapsibleSection';
import { RESIZABLE_THREE_COLUMNS } from '../../utils/resizableThreeColumns';

/**
 * 훈련 상세 오른쪽 영역 - 힌트 및 정답 확인 패널
 */
const TrainingDetailSidePanel = ({
  hint,
  answers,
  step,
  showHint,
  showAnswers,
  onHintToggle,
  onAnswersToggle,
  hintWidth,
  minHintWidth,
}) => (
  <Paper
    sx={{
      width: hintWidth,
      minWidth: minHintWidth,
      maxWidth: `${RESIZABLE_THREE_COLUMNS.maxRightPercent}%`,
      flexShrink: 0,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      border: '1px solid #e0e0e0',
      borderRadius: 1,
    }}
  >
    <TrainingDetailCollapsibleSection
      title="힌트"
      expanded={showHint}
      onToggle={onHintToggle}
    >
      <Box sx={{ p: 2 }}>
        {hint ? (
          <Paper sx={{ p: 2, bgcolor: '#fff3cd' }}>
            <Typography variant="body2" whiteSpace="pre-wrap">
              {hint}
            </Typography>
          </Paper>
        ) : (
          <Typography variant="body2" color="text.secondary">
            힌트가 없습니다.
          </Typography>
        )}
      </Box>
    </TrainingDetailCollapsibleSection>

    <TrainingDetailCollapsibleSection
      title="정답 확인"
      expanded={showAnswers}
      onToggle={onAnswersToggle}
      showBorderTop
      flex
    >
      <Box sx={{ p: 2, overflow: 'auto', flex: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {answers.map((file, index) => (
            <Paper key={index} sx={{ p: 2, bgcolor: '#f5f5f5' }}>
              <Typography variant="body2" fontWeight={600} gutterBottom>
                {file.fileName}
              </Typography>
              {step === 1 ? (
                <Typography variant="body2" color="text.secondary">
                  정답: {file.lineNum ? `${file.lineNum}번 라인` : '-'}
                </Typography>
              ) : (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}
                >
                  정답: {file.keyword ? file.keyword : '-'}
                </Typography>
              )}
            </Paper>
          ))}
        </Box>
      </Box>
    </TrainingDetailCollapsibleSection>
  </Paper>
);

export default TrainingDetailSidePanel;
